import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { DISTRIBUTION_RULE_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  ruleId: string
  communityId: string
}

const mutateUpdateRuleStatus = async ({ ruleId, communityId }: mutateProps) => {
  return await axiosAuth.patch(
    `${DISTRIBUTION_RULE_API(communityId)}/${ruleId}/status`
  );
};

const useUpdateRuleStatusMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateRuleStatus,
    ...queryParams,
  });

export default useUpdateRuleStatusMutation;
